import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Eye, MapPin, Printer } from 'lucide-react';
const deliverables = [{
  icon: <FileText size={32} data-id="element-205" />,
  title: 'Guía Paso a Paso (PDF)',
  description: 'El mapa exacto desde el viernes por la tarde hasta el lunes por la mañana.'
}, {
  icon: <Eye size={32} data-id="element-206" />,
  title: 'El Diccionario de Gestos',
  description: 'Cómo saber que tu hijo tiene que ir al baño ANTES de que él mismo lo sepa.'
}, {
  icon: <MapPin size={32} data-id="element-207" />,
  title: 'Protocolo de Salidas Seguras',
  description: 'El plan para ir al parque o al súper sin miedo a accidentes.'
}, {
  icon: <Printer size={32} data-id="element-208" />,
  title: 'Kit de Imprimibles',
  description: 'Tablas de seguimiento y tarjetas visuales para que tu hijo se sienta un campeón.'
}];
export function WhatYouGet() {
  return <section className="py-20 bg-white" data-id="element-209">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-210">
        <div className="text-center mb-16" data-id="element-211">
          <h2 className="text-3xl md:text-4xl font-bold text-slate mb-4" data-id="element-212">
            Lo que recibes hoy
          </h2>
          <p className="text-lg text-slate-light" data-id="element-213">
            Todo lo que necesitas para un fin de semana de éxito, sin relleno.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-214">
          {deliverables.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start gap-6 p-8 rounded-2xl bg-cream border border-teal/10 hover:border-teal/30 transition-colors" data-id="element-215">
              <div className="flex-shrink-0 w-16 h-16 rounded-2xl bg-teal/10 flex items-center justify-center text-teal" data-id="element-216">
                {item.icon}
              </div>
              <div data-id="element-217">
                <h3 className="text-xl font-bold text-slate mb-2" data-id="element-218">
                  {item.title}
                </h3>
                <p className="text-slate-light leading-relaxed" data-id="element-219">
                  {item.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}